// extracted by mini-css-extract-plugin
export default {"endAdornment":"SearchInput_endAdornment__yDyAE"};